import { GridApi } from "@ag-grid-community/core";
import debounce from "lodash-es/debounce";

const callOnRowHeightChanged = (api: GridApi) => {
  const selectedNodes = api.getSelectedNodes();
  const selectedRowIds = new Set(selectedNodes.map((rowNode) => rowNode.id));
  api.onRowHeightChanged();
  setTimeout(() => {
    api.forEachNode((rowNode) => {
      if (selectedRowIds.has(rowNode.id)) {
        rowNode.setSelected(true);
      }
    });
  }, 0);
};

const debouncedRowHeightChanged = debounce(callOnRowHeightChanged, 50, {
  maxWait: 500,
  trailing: true,
});

export default debouncedRowHeightChanged;
